import { createSlice } from '@reduxjs/toolkit';
import { Sentry } from '@/sentry';

const getStoredInfo = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo'));
  } catch (error) {
    // userInfo corrupto/no-JSON en localStorage (residuo de sesión vieja):
    // sin este catch, esto truena al importar el módulo, antes de que
    // React monte nada, dejando la app en blanco sin forma de recuperarse.
    console.error('userInfo inválido en localStorage, se limpiará:', error);
    Sentry.captureException(error, { tags: { source: 'userInfo-bootstrap' } });
    localStorage.removeItem('userInfo');
    return null;
  }
};

const initialState = getStoredInfo() || {};

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      return action.payload;
    },
    updateRfc: (state, action) => {
      state = { ...state, rfc: action.payload };
    }
  }
});

export const { setUserInfo, updateRfc } = userInfoSlice.actions;
export default userInfoSlice.reducer;
